import { getFullTranslations } from './util';

export const enTranslationMessages = getFullTranslations('en');
